import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './style.scss';

export default class Button extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    type: 'button',
    text: '',
    disabled: false,
    onClick: () => null
  };

  render() {
    const { type, text, disabled, onClick, ...rest } = this.props;

    return (
      <button
        {...rest}
        type={type}
        className={classNames(style.button, {
          [style.disabled]: disabled
        })}
        disabled={disabled}
        onClick={onClick}
      >
        {text}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.js